// extracted by mini-css-extract-plugin
export default {"link":"L8NqRm","list":"H8tUyE","open":"sEd5TL","item":"FcI0_y","bold":"XXiVvo"};